import httpService from "./httpService";

// IB Service Turn On Response Types
export interface IBServiceTurnOnResponse {
  success: boolean;
  data: {
    message: string;
    isAuthenticated: boolean;
    schedulerRunning: boolean;
    serviceIpAddress: string;
    outgoingIp: string;
    authentication: {
      hasOAuthToken: boolean;
      lastAuthTime: number | null;
    };
  };
  timestamp: number;
}

// IB Service Turn Off Response Types
export interface IBServiceTurnOffResponse {
  success: boolean;
  data: {
    message: string;
    isAuthenticated: boolean;
    schedulerRunning: boolean;
  };
  timestamp: number;
}

// IB Service Health Response Types
export interface IBServiceHealthAuthentication {
  isAuthenticated: boolean;
  hasOAuthToken: boolean;
  lastAuthTime: number | null;
  lastTickleTime: number | null;
  timeSinceLastAuth: number | null;
  timeSinceLastTickle: number | null;
  brokerageSessionAuthenticated: boolean;
  brokerageSessionConnected: boolean;
}

export interface IBServiceHealthTickleScheduler {
  isRunning: boolean;
  retryCount: number;
  intervalMs: number;
}

export interface IBServiceHealthResetPeriodWindow {
  start: string;
  end: string;
}

export interface IBServiceHealthResetEvent {
  schedulerRunning: boolean;
  isInResetPeriod: boolean;
  isDailyReset: boolean;
  isWeeklyReset: boolean;
  resetPeriodEndUTC: string | null;
  currentTimeUTC: string;
  upcomingResetPeriods: IBServiceHealthResetPeriodWindow[];
}

export interface IBServiceHealthBrokerageSession {
  authenticated: boolean;
  competing: boolean;
  connected: boolean;
  message: string;
  MAC: string;
  serverInfo: {
    serverName: string;
    serverVersion: string;
  };
  hardware_info: string;
  fail: string;
}

export interface IBServiceHealthResponse {
  success: boolean;
  service: string;
  serviceStatus: "ON" | "OFF";
  environment: string;
  serviceIpAddress: string;
  outgoingIp: string;
  timestamp: number;
  currentTimeUTC: string;
  currentTimeET: string;
  uptime: number;
  authentication: IBServiceHealthAuthentication;
  tickleScheduler: IBServiceHealthTickleScheduler;
  resetEvent: IBServiceHealthResetEvent;
  ibkrBrokerageSession: IBServiceHealthBrokerageSession | null;
  error?: string;
}

export interface AdvisorHealthEntry {
  advisorIbkrAccountId: string;
  advisorAlias: string;
  health: IBServiceHealthResponse | null;
  error: string | null;
}

class ServicesHealthService {
  private static instance: ServicesHealthService;

  private constructor() {}

  public static getInstance(): ServicesHealthService {
    if (!ServicesHealthService.instance) {
      ServicesHealthService.instance = new ServicesHealthService();
    }
    return ServicesHealthService.instance;
  }

  public async getAllIBServiceHealth(): Promise<AdvisorHealthEntry[]> {
    const response = await httpService.get<AdvisorHealthEntry[]>("/v2/admin/health/ib-services");
    return response.data;
  }

  public async turnOnIBService(advisorIbkrAccountId: string): Promise<IBServiceTurnOnResponse> {
    const response = await httpService.post<IBServiceTurnOnResponse>(
      `/v2/admin/health/ib-service/turn-on?advisorIbkrAccountId=${encodeURIComponent(advisorIbkrAccountId)}`,
      {},
    );
    return response.data;
  }

  public async turnOffIBService(advisorIbkrAccountId: string): Promise<IBServiceTurnOffResponse> {
    const response = await httpService.post<IBServiceTurnOffResponse>(
      `/v2/admin/health/ib-service/turn-off?advisorIbkrAccountId=${encodeURIComponent(advisorIbkrAccountId)}`,
      {},
    );
    return response.data;
  }
}

export const servicesHealthService = ServicesHealthService.getInstance();
export default servicesHealthService;

